<div class="d-flex align-items-center justify-content-center rounded-circle text-avatar">
  <bdg-label [type]="labelType">{{ firstCharacter }}</bdg-label>
</div>
